import { FC, useMemo } from 'react'

import { TabBar } from 'antd-mobile'
import { useLocation } from 'react-router-dom'

import Icon from '@/components/Icon'

import { useUnclaimedRewardsAtom, useMessageAtom, loginStateAtom } from '@/store'
import { customJumpHref, handleClickMessageTrack, handleImClickTrack } from '@/utils'
import { useAtomValue } from 'jotai'

const TabBarCom: FC = () => {
  const location = useLocation()
  const { pathname } = location
  const { unclaimedRewards } = useUnclaimedRewardsAtom()
  const { hasUnreadMessage } = useMessageAtom()
  const isLogin = useAtomValue(loginStateAtom)

  const taskTip =
    "relative after:absolute after:right-[-10px] after:top-[-10px] after:block after:h-[15px] after:w-[15px] after:rounded-full after:bg-red-500 after:content-['']"

  const setRouteActive = (value: string) => {
    if (value === '/message') {
      handleImClickTrack('contact', '')
      handleClickMessageTrack()
    }

    customJumpHref(value)
  }

  const activeUrl = useMemo(() => {
    return pathname
  }, [pathname])

  const tabs = [
    {
      key: '/',
      // title: 'Discover', // 首页
      icon: <Icon name='DiscoverActive' className='guide-home w-[52px]' />,
    },
    {
      key: '/library',
      // title: 'Library', // 待办
      icon: <Icon name='Library' className='guide-library w-[52px]' />,
    },
    {
      key: '/message',
      // title: 'Message', // 消息
      icon: (
        <div className={hasUnreadMessage ? taskTip : ''}>
          <Icon name='Group' className='guide-message w-[52px]' />
        </div>
      ),
    },
    {
      key: '/personal',
      // title: 'Me', // 我的
      icon: (
        <div className={isLogin && unclaimedRewards.no_received_task ? taskTip : ''}>
          <Icon name='Me' className='guide-personal w-[52px]' />
        </div>
      ),
    },
  ]

  return (
    <TabBar
      activeKey={activeUrl}
      onChange={(value) => setRouteActive(value)}
      className='h-full [--adm-font-size-2:18px] [&_.adm-tab-bar-item-active]:[--adm-color-primary:#666] [&_.adm-tab-bar-item-title]:mt-[5px]'
    >
      {tabs.map((item) => (
        <TabBar.Item key={item.key} icon={item.icon} />
      ))}
    </TabBar>
  )
}

export default TabBarCom
